import React, { Fragment } from "react";

const questions = [
	{
		question:
			"Is there a minimum amount I need to offer as a reward or prize to eksplode! Members under the eac program, or to the eksplode! Stars under the vac program?",
		answer: `No. But be mindful that eksplode! Members and eksplode! Stars are lured to promote products/services based on the amount of the reward/prize offered. The higher the amount, the higher the probability of promotion. `,
	},
	{
		question: `Can I increase or decrease the amount offered as a reward or prize at any time?`,
		answer: `You may only increase the reward or prize amount at any time. However, you may not decrease the amount offered on our vac program, but may do so under our eac program. Please note that any decrease on our eac program will not take effect until one minute past the 24th hour after the decrease has been made. This period allows us to notify our eksplode! Members of the change and allow them to pull or suspend promoting your product/service.`,
	},
	{
		question: `What happens if a customer wants a refund on a product or service sold though eksplode!?`,
		answer: `We require our Retailers to post and maintain a customer notice, warning them that all returns/refunds will be subjected to a surcharge/restocking fee equal to or greater than the reward/prize amount paid to our Members/Stars, plus our processing fee of 5%. This policy will be strictly enforced and is necessary to prevent individuals from scamming our system. `,
	},
	{
		question: `Can eksplode! guarantee the Retailer that its Members and Stars will select its products/services for promotion?`,
		answer: `No. whether or not an eksplode! Member or eksplode! Star selects a particular product or service to promote can depend on a number of factors, such as what the product or service is, and whether the reward/prize offered is alluring enough. `,
	},
	{
		question: `What happens if I participate in eksplode!'s vac program and my product/service is not selected by an eksplode! Star for promotion? `,
		answer: `If your product/service is not selected within 30 days from the date the prize offered is placed in our escrow account, you may withdraw the offer at no charge and will receive your entire prize amount back, or, you may elect to let the offer sit until such time as you wish to withdraw it. `,
	},
	{
		question: ` By paying the prize to an eksplode! Star for their most-liked video promoting my product/service, do I automatically own the video or intellectual property rights? `,
		answer: `No. All videos uploaded onto eksplode!'s vac platform becomes exclusive property of eksplode! Marketing, including the 

        concepts portrayed in each video, as we purchase all submissions in advance and thus own them. However, Retailers 
        
        may contact us to discuss options.`,
	},
	{
		question: `Is there a limit on number of products/services a Retailer can list on eksplode!'s eac or vac program?`,
		answer: `No. Retailer's can upload their entire catalog or list as many services as they wish to have promoted.`,
	},
	{
		question: ` Can a Retailer, participating in eksplode!'s vac program, renew the prize offered to ekslpode Stars for promoting the 

        same product/service previously promoted? `,
		answer: `Yes. A Retailer may continue to participate in eksplode!'s vac program, even after a prize is rewarded to an eksplode! 

        Star, as long as the Retailer places another prize amount in eksplode!'s escrow account. `,
	},
	{
		question: `Can I sell anything or list any type of service on eksplode!'s platform? `,
		answer: `No. Our platform attracts participants and customers of all ages. As such, we are dedicated to maintaining Retailer 

        catalogs of family and professional tastes. Our staff will monitor all Retailer postings to ensure all products and 
        
        services offered meet our guidelines`,
	},
];

const FAQ = (props) => {
	const { next, previous } = props;
	return (
		<div className="container px-5 pt-5 custom-modal faq">
			<div className="row">
				<h2>FAQs</h2>
			</div>
			{questions.map(({ question, answer }, index) => (
				<Fragment>
					<div className="row mb-3">
						<ul>
							<li>
								<b>
									{index + 1}. {question}
								</b>
							</li>
							<li>
								<b>Answer.</b> {answer}
							</li>
						</ul>
					</div>
				</Fragment>
			))}
			<div className="row mt-3 justify-content-center">
				<button
					className="btn btn-solid mx-1"
					style={{ minWidth: "150px" }}
					onClick={previous}>
					Previous
				</button>
				<button
					className="btn btn-solid mx-1"
					style={{ minWidth: "150px" }}
					onClick={next}>
					Next
				</button>
			</div>
		</div>
	);
};

export default FAQ;
